import { Button, Icon, Tooltip, useDisclosure } from '@wegroup/design-system';
import { useTranslation } from 'react-i18next';
import FinishBasketModal from '@flows/src/components/flow-products/quotes/basket/FinishBasketModal';
import { useFlowsSession } from '@flows/src/api/getFlowsSessionById';
import { useParty } from '@parties/src/features/detail/api/getParty';

import useYellowhiveFlowProductSelectionStore from '@flows/src/store/zustand/flows-products/useYellowhiveFlowProductSelectionStore';
import { FinishBasketYellowHiveContactPersonModal } from '@flows/src/components/flow-products/quotes/basket/actions/yellowhive-party-creation-modal/FinishBasketYellowHiveContactPersonModal';
// import { recalculateYellowhiveSimulationBySessionId } from 'wg-api-sdk';

interface Props {
  sessionId: string;
}

const YellowhiveBasketFinishButton = ({ sessionId }: Props) => {
  const { t } = useTranslation();
  // sessionId is already provided via props
  const { data: sessionData } = useFlowsSession(sessionId);
  const partyId = sessionData?.prospect?.id || '';
  const { data: partyData, isSuccess: isPartyDataSuccess } = useParty(partyId);
  const { isOpen, onClose, onOpen } = useDisclosure();
  const {
    isOpen: isContactPersonModalOpen,
    onOpen: onContactPersonModalOpen,
    onClose: onContactPersonModalClose,
  } = useDisclosure();

  const selectedItems = useYellowhiveFlowProductSelectionStore(
    (state) => state.selectedYellowhiveItems,
  );
  const isDisabled = selectedItems.length === 0;

  const handlePartyCreationFinish = () => {
    onContactPersonModalClose();
    onOpen();
  };

  const getTooltipLabel = () => {
    if (isDisabled) {
      return t('FLOWS_PRODUCTS_BASKET_ACTIONS_VALIDATE_EMPTY_TOOLTIP');
    }
    return '';
  };

  const handleFinishWorkflow = () => {
    if (partyData?.contact_person) {
      onOpen();
    } else {
      onContactPersonModalOpen();
    }
  };

  return (
    <>
      {partyData && (
        <FinishBasketYellowHiveContactPersonModal
          party={partyData}
          sessionId={sessionId}
          isOpen={isContactPersonModalOpen}
          onClose={onContactPersonModalClose}
          onFinish={handlePartyCreationFinish}
        />
      )}
      <FinishBasketModal
        isOpen={isOpen}
        onClose={onClose}
        sessionId={sessionId}
      />
      <Tooltip isDisabled={!isDisabled} label={getTooltipLabel()}>
        <Button
          isDisabled={isDisabled && isPartyDataSuccess}
          onClick={handleFinishWorkflow}
          rightIcon={<Icon name="GeneralActionsArrowRight" />}
          flex={{ base: '1', tablet: 'initial' }}
        >
          {t('FINISH')}
        </Button>
      </Tooltip>
    </>
  );
};

export default YellowhiveBasketFinishButton;
